<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 0 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>
  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsDaily']"
        >
          Metrics daily
        </a>

        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsWeekly']"
        >
          Metrics weekly
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/actionsBacklog']"
        >
          Actions backlog
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalClusters']"
        >
          Cannibal clusters
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/keywordInsights']"
        >
          Keyword insights
        </a>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalEdges']"
        >
          Cannibal edges
        </a>
        <a class="btn btn-dark btn-sm btn-reg"> Reviews </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/technicalAudits']"
        >
          Technical Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/sitemapAudits']"
        >
          Sitemap Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/offPagePerformance']"
        >
          Off-page
        </a>
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm border-0 bg-light p-3">
        <div class="row align-items-center">
          <div class="col-3">
            <label class="form-label text-xs font-weight-bold">Rating</label>
            <div class="btn-group w-100" role="group">
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setRatingFilter(1, 2)"
                [class.active]="ratingMax === 2"
              >
                1-2★
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setRatingFilter(3, 3)"
                [class.active]="ratingMin === 3 && ratingMax === 3"
              >
                3★
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setRatingFilter(4, 5)"
                [class.active]="ratingMin === 4"
              >
                4-5★
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setRatingFilter(null, null)"
                [class.active]="!ratingMin && !ratingMax"
              >
                All
              </button>
            </div>
          </div>
          <div class="col-3 pt-4">
            <label class="form-label text-xs font-weight-bold pl-3 pr-1 pt-3"
              >Reply Status</label
            >
            <select
              class="form-select form-select-sm text-dark"
              [(ngModel)]="replyStatus"
              (change)="getData()"
            >
              <option value="">All Status</option>
              <option value="none">None</option>
              <option value="draft">Draft</option>
              <option value="approved">Approved</option>
              <option value="published">Published</option>
            </select>
          </div>
          <div class="col-3 pt-4">
            <label class="form-label text-xs font-weight-bold pr-1 pt-3"
              >Location</label
            >
            <select
              class="form-select form-select-sm text-dark"
              [(ngModel)]="locationId"
              (change)="getData()"
            >
              <option value="">All Locations</option>
              <option *ngFor="let loc of locations" [value]="loc._id">
                {{ loc.title }}
              </option>
            </select>
          </div>
          <!-- <div class="col-md-3 d-flex align-items-end">
            <div class="form-check form-switch mb-0">
              <input class="form-check-input" type="checkbox" [(ngModel)]="hasComment" (change)="getData()">
              <label class="form-check-label text-xs">With comments only</label>
            </div>
          </div> -->
          <div class="col-3">
            <div class="row pt-4">
              <div class="col-6">
                <a
                  class="btn btn-dark btn-sm btn-step"
                  [routerLink]="['/observability/seo/localSeo/locations']"
                >
                  Locations
                </a>
              </div>
              <div class="col-6">
                <a
                  class="btn btn-dark btn-sm btn-step"
                  [routerLink]="['/observability/seo/localSeo/actions']"
                >
                  Actions
                </a>
              </div>
              <!-- </div>
            <div class="row"> -->
              <!-- <div class="col-12">
                <a
                  class="btn btn-dark btn-sm btn-step"
                  [routerLink]="['/observability/seo/localSeo/actions']"
                >
                  Actions
                </a>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body p-0">
          <label class="form-label fw-bold text-dark pt-3 pl-3"
            >Total reviews : {{ totalReviews }}</label
          >
          <ul class="list-group list-group-flush">
            <li
              *ngFor="let review of data"
              class="list-group-item list-group-item-action p-4 border-0 border-bottom"
              (click)="openDetail(review)"
              style="cursor: pointer"
            >
              <div class="row w-100">
                <div class="col-md-2">
                  <div class="text-center">
                    <div class="d-flex justify-content-center mb-1 gap-1">
                      <ng-container *ngFor="let star of stars">
                        <i
                          *ngIf="star <= review.starRating"
                          class="fas fa-star text-warning mr-0"
                        ></i>
                      </ng-container>
                    </div>

                    <span class="text-xs text-secondary">
                      {{ review.starRating }} Stars
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <h6 class="mb-1 text-sm">{{ review.reviewerName }}</h6>
                  <p class="text-xs text-secondary mb-2">
                    {{ review.createTime | date : "mediumDate" }}
                  </p>
                  <p
                    class="text-sm mb-0 text-dark font-weight-normal text-truncate-2"
                  >
                    {{ (review.comment || "(No comment)") | slice:0:59 }}{{ (review.comment || "").length > 59 ? '...' : '' }}
                  </p>
                </div>
                <div class="col-md-3 text-end">
                  <span
                    class="badge badge-sm mb-2"
                    [ngClass]="{
                      'bg-gradient-info': review.reply?.status === 'draft',
                      'bg-gradient-warning':
                        review.reply?.status === 'approved',
                      'bg-gradient-success':
                        review.reply?.status === 'published',
                      'bg-gradient-secondary':
                        !review.reply?.status ||
                        review.reply?.status === 'none',
                    }"
                  >
                    {{ review.reply?.status || "none" | uppercase }}
                  </span>
                  <div class="d-flex flex-column align-items-end">
                    <small class="text-xs text-secondary">Location ID:</small>
                    <small class="text-xs font-weight-bold">{{
                      review.locationId
                    }}</small>
                  </div>
                </div>
              </div>
            </li>
            <li
              *ngIf="data.length === 0"
              class="list-group-item text-center py-5"
            >
              No reviews found match your criteria
            </li>
          </ul>
        </div>
        <div
          class="card-footer py-2 d-flex justify-content-between align-items-center"
        >
          <small class="text-secondary text-xs"
            >Page {{ currentPage }} of {{ totalPages }}</small
          >
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="changePage(currentPage - 1)"
                  >Previous</a
                >
              </li>
              <li
                class="page-item"
                [class.disabled]="currentPage === totalPages"
              >
                <a class="page-link" (click)="changePage(currentPage + 1)"
                  >Next</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
